export default __webpack_public_path__ + "static/media/drag-point-restricted.20e9a449.svg";